// test883
(883 && 0);
